export default {
  'pages.markets.subtitle.apps':
    'Discover and activate business applications to enhance your workspace.',
  'pages.markets.subtitle.skill':
    'Explore skills and capabilities to empower your AI assistants.',
  'pages.markets.subtitle.mcp':
    'Discover and connect MCP servers and tools to extend external integrations.',
  'pages.markets.subtitle.digital_human':
    'Discover official digital humans with reusable instructions and Skills.',
  'pages.markets.subtitle.plugin':
    'Discover Zhiyue client plugins and download packages to extend the client.',
  'pages.markets.tab.apps': 'App Market',
  'pages.markets.tab.skill': 'Skill Market',
  'pages.markets.tab.mcp': 'MCP Market',
  'pages.markets.tab.digital_human': 'Digital Human Market',
  'pages.markets.tab.plugin': 'Plugin Market',
  'pages.markets.sources': 'Sources',
  'pages.markets.source.all': 'All',
  'pages.markets.source.official': 'Official',
  'pages.markets.skillsShCountTooltip':
    'skills.sh includes {count} skills in total; the top 600 are browsable.',
  'pages.markets.search': 'Search',
  'pages.markets.searchPlaceholder.apps':
    'Search by app name, description, or developer...',
  'pages.markets.searchPlaceholder.skill':
    'Search by Skill name, capability, or publisher...',
  'pages.markets.searchPlaceholder.mcp':
    'Search by MCP tool name, capability, or publisher...',
  'pages.markets.searchPlaceholder.digital_human':
    'Search by digital human name, capability, or publisher...',
  'pages.markets.searchPlaceholder.plugin':
    'Search plugin name, code or description...',
  'pages.markets.sort.popular': 'Most Popular',
  'pages.markets.sort.latest': 'Recently Added',
  'pages.markets.sort.name': 'Name',
  'pages.markets.sort.all_time': 'All Time',
  'pages.markets.sort.trending': 'Trending',
  'pages.markets.sort.hot': 'Hot',
  'pages.markets.sortDisabledWithKeyword':
    'Sorting is unavailable during search',
  'pages.markets.categories': 'Categories',
  'pages.markets.all': 'All',
  'pages.markets.loadedProgress': 'Loaded {loaded} / {total} total',
  'pages.markets.loadedSimple': 'Loaded {loaded}',
  'pages.markets.empty': 'No items available',
  'pages.markets.noMatchingResults': 'No matching results found',
  'pages.markets.emptyDescription':
    'Try adjusting your search query or selecting another category.',
  'pages.markets.loadError': 'Failed to load marketplace data',
  'pages.markets.loadErrorDesc':
    'Unable to fetch data at this moment. Please check your network and retry.',
  'pages.markets.failedSourcesWarning':
    'The following sources are temporarily unavailable: {sources}',
  'pages.markets.retry': 'Retry',
  'pages.markets.refresh': 'Refresh',
  'pages.markets.clearFilters': 'Clear Filters',
  'pages.markets.loadingMore': 'Loading...',
  'pages.markets.noMore': 'No more',
  'pages.markets.loadMoreRetry': 'Failed to load, click to retry',
  'pages.markets.action.open': 'Open App',
  'pages.markets.action.install': 'Install',
  'pages.markets.action.installed': 'Activated',
  'pages.markets.action.freeActivate': 'Activate Free',
  'pages.markets.action.paidActivate': 'Purchase',
  'pages.markets.action.contactRequired': 'Contact Sales',
  'pages.markets.action.copyCommand': 'Copy Install Command',
  'pages.markets.visitHomepage': 'Visit official homepage',
  'pages.markets.viewOnSource': 'View on {source}',
  'pages.markets.codeRepository': 'Code Repository',
  'pages.markets.links': 'Links',
  'pages.markets.installCommand': 'Install Command',
  'pages.markets.serviceEndpoint': 'Service Endpoint',
  'pages.markets.thirdPartyDisclaimer':
    'This content is provided by a third-party source and has not been reviewed by CoralReef. Please verify that the source is trustworthy before installing.',
  'pages.markets.sourceLabel': 'Source',
  'pages.markets.versionLabel': 'Version',
  'pages.markets.installsLabel': 'Installs',
  'pages.markets.identifierLabel': 'Identifier',
  'pages.markets.copy': 'Copy',
  'pages.markets.copySuccess': 'Install command copied to clipboard',
  'pages.markets.copyEndpointSuccess': 'Service endpoint copied to clipboard',
  'pages.markets.copyFailed': 'Failed to copy, please copy manually',
  'pages.markets.unknownPublisher': 'Unknown Publisher',
  'pages.markets.unknownDeveloper': 'Unknown Developer',
  'pages.markets.noDescription': 'No description provided',
  'pages.markets.officialBadge': 'Official',
  'pages.markets.featuredBadge': 'Featured',
  'pages.markets.verifiedBadge': 'Verified by source',
  'pages.markets.appBadge': 'App',
  'pages.markets.free': 'Free',
  'pages.markets.paid': 'Paid',
  'pages.markets.pricePending': 'Pricing Pending',
  'pages.markets.installs': '{count} installs',
  'pages.markets.downloads': '{count} downloads',
  'pages.markets.version': 'v{version}',
  'pages.markets.detailTitle': 'Application Details',
  'pages.markets.description': 'Description',
  'pages.markets.developer': 'Developer',
  'pages.markets.certification': 'Certification',
  'pages.markets.official': 'Official Certified',
  'pages.markets.unverified': 'Third-party',
  'pages.markets.category': 'Category',
  'pages.markets.uncategorized': 'Uncategorized',
  'pages.markets.price': 'Price',
  'pages.markets.previewImages': 'Previews',
  'pages.markets.noPreview': 'No preview images',
  'pages.markets.previewAlt': '{name} preview {index}',
  'pages.markets.confirmFreeTitle': 'Confirm Free Activation',
  'pages.markets.confirmFreeDescription':
    'Activate "{name}"? It will be ready for use in your workbench once activated.',
  'pages.markets.confirmPaidTitle': 'Confirm Purchase',
  'pages.markets.confirmPaidDescription':
    'Purchase "{name}" ({price})? You will be redirected to checkout.',
  'pages.markets.confirm': 'Confirm',
  'pages.markets.cancel': 'Cancel',
  'pages.markets.activateSuccess': 'Activated successfully',
  'pages.markets.alreadyActive':
    'This application is already activated for the current tenant',
  'pages.markets.activateError': 'Activation failed, please try again later',
  'pages.markets.installSuccess': 'Installed successfully',
  'pages.markets.installError': 'Installation failed, please try again later',
  'pages.markets.skillPackageMissing':
    'This skill has no installation package yet',
  'pages.markets.orderError': 'Failed to create order, please try again later',
  'pages.markets.contactReason':
    'Please contact operations to activate this application.',
  'pages.markets.unavailableUrl': 'No valid access URL configured yet',
  'pages.markets.close': 'Close',
  'pages.markets.action.download': 'Download',
  'pages.markets.downloadError': 'Download failed. Please try again later.',
  'pages.markets.pluginEngine': 'Compatible engine',
  'pages.markets.pluginPermissions': 'Permissions',
  'pages.markets.pluginNoPermissions': 'No extra permissions',
  'pages.markets.pluginPermission.http': 'Network requests',
  'pages.markets.pluginPermission.commands': 'Run commands',
  'pages.markets.pluginPermission.storage': 'Local storage',
  'pages.markets.pluginPackageSize': 'Package size',
  'pages.markets.pluginUpdatedAt': 'Updated',
  'pages.markets.pluginReadme': 'README',
  'pages.markets.pluginVersions': 'Versions',
  'pages.markets.pluginLatestTag': 'Current',
  'pages.markets.pluginDownloadLatest': 'Download latest',
};
